import { GetServerSideProps } from 'next'
import PopularSearch from 'services/Search/screens/PopularSearch'

export const getServerSideProps: GetServerSideProps = async (
  context,
) => {
  return {
    props: {
      query: context.query,
    },
  }
}

export default PopularSearch
